angular.module('console')

.controller('UtilitiesConsoleController', ['$scope', '$q', 'Practice', 'ProviderInvitation',
    function($scope, $q, Practice, ProviderInvitation){
        $scope.testSearch = function() {

            var ALL_KEYWORDS = ['test', 'wolf', 'bob', 'oral', 'dental', 'nonexistent', 'smile'];
            var p = {
                min: Number.MAX_SAFE_INTEGER,
                max: 0,
                count: 0,
                totalTime: 0
            };

            var recursion = function(searchValue) {
                console.log('running a search: ' + searchValue);

                var providersPromise = Practice.searchPractice({search: searchValue}).$promise;
                var invitationsPromise = ProviderInvitation.searchProviderInvitation({search: searchValue}).$promise;
                var start = Date.now();
                $q.all([providersPromise, invitationsPromise]).then(function (results) {
                    var elapsed = Date.now() - start;
                    console.log("elapsed: " + elapsed);    

                    p.min = Math.min(elapsed, p.min);
                    p.max = Math.max(elapsed, p.max);
                    p.count++;
                    p.totalTime += elapsed;
                    p.ave = Math.round(p.totalTime / p.count);
                    console.log('P = ' + JSON.stringify(p));

                    // next search term
                    var term = ALL_KEYWORDS.shift();
                    if (term) {
                        recursion(term);
                    }
                });
            };

            recursion(ALL_KEYWORDS.shift());

            return p;
        };
    }]);
